(function () {
    function initAccordion(root) {
        if (!root || root.dataset.accordionReady === '1') {
            return;
        }

        root.dataset.accordionReady = '1';

        root.addEventListener('click', (event) => {
            const head = event.target.closest('[class$="__head"]');

            if (!head || !root.contains(head)) {
                return;
            }

            const item = head.closest('[class$="__item"]');

            if (!item) {
                return;
            }

            const isOpen = item.classList.contains('is-open');
            item.classList.toggle('is-open', !isOpen);
            head.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
    }

    function initPrinciples(block) {
        if (!block || block.dataset.principlesReady === '1') {
            return;
        }

        block.dataset.principlesReady = '1';

        const accordion = block.querySelector('[data-rutina-accordion]');
        initAccordion(accordion);
    }

    function expandAllAccordions() {
        document.querySelectorAll('[data-rutina-principles] [class$="__item"]').forEach((item) => {
            item.classList.add('is-open');
            const head = item.querySelector('[class$="__head"]');

            if (head) {
                head.setAttribute('aria-expanded', 'true');
            }
        });
    }

    function boot() {
        document.querySelectorAll('[data-rutina-principles]').forEach(initPrinciples);
    }

    window.addEventListener('beforeprint', expandAllAccordions);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }
})();
